import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'hq-widget',
    standalone: true,
    imports: [CommonModule],
    template: `
        <section id="hq" class="pt-2 pb-0 relative overflow-hidden">

            <!-- Handwriting phrase mobile -->
            <div class="text-center md:hidden mb-2">
                <img src="/assets/img/home/handwriting_phrase.png"
                    alt="Enjoy the atmosphere at Usina Cowork"
                    loading="lazy"
                    class="w-full fadein-right mx-auto"
                    style="position: relative; z-index: 10;"
                    />
            </div>
            
            <div class="flex flex-column mb-0 md:mb-2 relative w-full md:w-10 lg:w-7 px-4 md:px-8">
                <h2 class="font-heavy h2-mobile md:text-6xl mb-4 line-height-1">Embrace nature.</h2>
                <h3 class="font-medium text-3xl md:text-5xl mb-4 md:line-height-2">
                    Nuestras locaciones en <br> Chacarita y San Isidro.
                </h3>
                <p class="font-regular text-lg text-700 md:mb-4 line-height-3 max-w-40rem">
                    Nuestras sedes están ubicadas en áreas clave de Buenos Aires, 
                    todas con excelentes conexiones de transporte. Elegí la que más te convenga.
                </p>

                <div class="flex flex-column md:flex-row md:justify-content-start md:align-items-start md:gap-4 w-full max-w-40rem">
                    
                    <div class="">
                        <a href="https://maps.app.goo.gl/P52tekBWCU9bUiES6" target="_blank" 
                            class="address-link block no-underline text-color pt-4 md:py-2 border-round-xl">
                            <div class="flex align-items-start gap-3">
                                <i class="pi pi-map-marker text-2xl text-800 mt-1 transition-colors duration-300"></i>
                                <div>
                                    <div class="flex align-items-center gap-2 mb-1">
                                        <span class="font-medium text-900 text-xl transition-colors duration-300">CHACARITA</span>
                                    </div>
                                    <span class="block font-regular text-700">Castillo 1366, CABA</span>
                                    
                                    <span class="text-xs text-primary font-medium mt-0 md:mt-2 block hover-reveal">Ver en mapa →</span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="flex-1">
                        <a href="https://maps.app.goo.gl/pY4cDcErTDdYV2c67" target="_blank" 
                            class="address-link block no-underline text-color py-0 md:py-2 border-round-xl">
                            <div class="flex align-items-start gap-3">
                                <i class="pi pi-map-marker text-2xl text-800 mt-1 transition-colors duration-300"></i>
                                <div>
                                    <div class="flex align-items-center gap-2 mb-1">
                                        <span class="font-medium text-900 text-xl transition-colors duration-300">SAN ISIDRO</span>
                                    </div>
                                    <span class="block font-regular text-700">Av. Libertador esquina Ituzaingó</span>
                                    
                                    <span class="text-xs text-primary font-medium mt-0 md:mt-2 block hover-reveal">Ver en mapa →</span>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>
                
            </div>

            <div class="grid grid-nogutter relative z-1">

                <img src="/assets/img/home/LDI1.png" 
                    alt="Let's do it 2025 - Usina Cowork" 
                    loading="lazy"
                    class="hidden lg:block absolute z-5 pointer-events-none fadein-down"
                    style="top: -7rem; left: 50%; width: 38rem; transform: translateX(-50%)" />
                
                <div class="col-12 lg:col-6 flex flex-column justify-content-between relative z-2 pt-2 md:pt-6">

                    <div class="map-container relative w-full px-2 md:px-0 lg:pl-8 mb-4 lg:mb-6">
                        <img src="/assets/img/home/map_bg_desktop.png" 
                             alt="Mapa de ubicaciones Usina Cowork - Chacarita y San Isidro, Buenos Aires" 
                             loading="lazy"
                             class="hidden lg:block w-full h-full object-cover map-overlap" />
                        
                        <img src="/assets/img/home/map_bg_mobile.png" 
                             alt="Mapa de sedes Usina Cowork Buenos Aires" 
                             loading="lazy"
                             class="block lg:hidden p-2 w-full h-auto aspect-ratio-1 object-cover border-round-2xl" />
                    </div>

                </div>

                <div class="col-12 lg:col-6 hidden lg:block h-auto relative z-1">
                     <img src="/assets/img/home/hq_desktop_3.2.jpg" 
                          alt="Interior de la sede Usina Cowork San Isidro - Espacios de oficina privada" 
                          loading="lazy"
                          class="w-full h-full object-cover" 
                          style="min-height: 100%;" />
                     
                     <div class="absolute top-0 left-0 w-full h-full bg-black-alpha-10"></div>
                </div>

            </div>
                    


        </section>
    `,
    styles: [`
        /* Tipografías */
        .font-heavy { font-family: "ABCDiatype-Heavy", sans-serif; }
        .font-medium { font-family: "ABCDiatype-Medium", sans-serif; }
        .font-regular { font-family: "ABCDiatype-Regular", sans-serif; }

        .text-primary { color: #3445ED; }

        .group:hover .pi-map-marker { color: #00ff00; }
        
        /* LOGICA DEL OVERLAP */
        @media (min-width: 992px) {
            .map-overlap {
                width: 115% !important; 
                max-width: none !important;
                position: relative;
                z-index: 10;
                border-radius: 2rem;
            }
        }

        @media (max-width: 991px) {
            .map-overlap { width: 100%; }
        }

        /* Animación suave de entrada para la firma */
        .fadein-down {
            animation: fadeindown 1s ease-out;
        }
        @keyframes fadeindown {
            from { opacity: 0; transform: translate(-50%, -20px); }
            to { opacity: 1; transform: translate(-50%, 0); }
        }

        /* --- LÓGICA DE HOVER PERSONALIZADA --- */
        
        /* El elemento que está oculto por defecto */
        .hover-reveal {
            opacity: 0;
            transform: translateY(5px); /* Un pequeño desplazamiento sutil hacia abajo */
            transition: all 0.3s ease;
        }

        /* Cuando hacemos hover sobre el padre (.address-link), el hijo (.hover-reveal) aparece */
        .address-link:hover .hover-reveal {
            opacity: 1;
            transform: translateY(0);
        }

        /* Opcional: Para el icono de link externo */
        .external-icon {
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .address-link:hover .external-icon {
            opacity: 1;
        }
    `]
})
export class HqWidget { }